/**
 * EINE FREIGABE DIREKT AUFMACHEN (.233).
 *
 * ORIGINALTEXT MARVIN (25.09.2026, Bilder vom Tablet)
 *   „Wenn ich auf die „Freigabe" klicke komme ich nicht direkt an die Stelle
 *    wo ich die faz mit Foto(s) vorbereitet sehe um es mir anzusehen und dann
 *    zu versenden oder abzulehnen."
 *
 * Die Glocke öffnet die Akte auf dem Reiter der Behördenmappe und legt hier
 * ab, welche Freigabe gemeint ist. Die Mappe nimmt die Marke beim Laden EINMAL
 * und öffnet das Prüffenster mit den Fotos. Genommen ist genommen: ein
 * zweites Öffnen der Mappe von Hand springt nicht noch einmal auf.
 */
let marke: { auftragId: string; freigabeId: string | null } | null = null;

/** Der Name des Fensterereignisses, mit dem eine schon offene Mappe die
 *  Marke mitbekommt. */
export const FREIGABE_VORGEMERKT = 'mds-freigabe-vorgemerkt';

/**
 * IST DIE MAPPE SCHON OFFEN, LÄDT SIE NICHT NEU (.317). Marvin: „wenn du in
 * einem auftrag bist unter "Dokumente erzeugen" und du klickst dann über die
 * glocke auf "Ansehen und freigeben" dann kommt der popup nicht." Die Mappe
 * las die Marke nur beim ersten Laden. Jetzt meldet das Vormerken sich, und
 * eine offene Mappe nimmt die Marke sofort.
 */
export function freigabeVormerken(auftragId: string, freigabeId: string | null): void {
  marke = { auftragId, freigabeId };
  try {
    window.dispatchEvent(new CustomEvent(FREIGABE_VORGEMERKT, { detail: { auftragId } }));
  } catch { /* ohne Fenster (Prüfstand) nichts zu melden */ }
}

export function freigabeNehmen(auftragId: string): { freigabeId: string | null } | null {
  if (!marke || marke.auftragId !== auftragId) return null;
  const m = marke; marke = null;
  return { freigabeId: m.freigabeId };
}
